import React from "react";
import Container from "@material-ui/core/Container";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItem";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import NavigateNext from "@material-ui/icons/NavigateNext";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import logo from "../assets/Colored/Logo Only/GIQ Colored Logo.png";
import { mathAnxietyData } from "../quiz/mathAnxietyData.js";
import anxietyImg from "../assets/aq/anxiety.png";
import fenceImg from "../assets/aq/fence.png";
import loverImg from "../assets/aq/lover.png";

const styles = (theme) => ({
  root: {
    display: "flex",
    whiteSpace: "normal",
    width: "100%",
  },
});

class learningStyles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      selections: mathAnxietyData.qs.map((x) => ""),
      showSummary: false,
      summaryParam: "",
    };
  }

  onChange = (event) => {
    let s = this.state.selections;
    s[this.state.currentPage] = event.target.value;
    const page =
      this.state.currentPage === this.state.selections.length - 1
        ? this.state.currentPage
        : this.state.currentPage + 1;
    this.setState({ selections: s, currentPage: page });
  };

  handleNavigate = (event, direction) => {
    this.setState({ currentPage: this.state.currentPage + direction });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    var sum = 0;
    for (let i = 0; i < this.state.selections.length; i++) {
      sum += this.state.selections[i];
    }

    console.log(sum);

    const param = sum > 0 ? "anxiety" : sum === 0 ? "fence" : "lover";

    console.log(param);

    this.setState({
      showSummary: true,
      summaryParam: param,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Container maxWidth="xs">
        <br />
        <br />
        <center>
          <img src={logo} width={100} alt="logo" />
          <br />
          <br />
          <Typography variant="h4" component="h2">
            Is Math Causing Anxiety?
          </Typography>
        </center>
        <br />
        {this.state.showSummary ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <img
                src={
                  this.state.summaryParam === "anxiety"
                    ? anxietyImg
                    : this.state.summaryParam === "fence"
                    ? fenceImg
                    : loverImg
                }
                alt="header"
                width="100%"
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" alignItems="center">
                <Typography variant="h6" component="h5">
                  {mathAnxietyData.s[this.state.summaryParam].title}
                  <br />
                </Typography>
                <Typography>
                  <br />
                  {mathAnxietyData.s[this.state.summaryParam].p1}
                </Typography>
                <br />
                <Grid item xs={12}>
                  <Typography>
                    <br />
                    <b>
                      {mathAnxietyData.s[this.state.summaryParam].subtitle1}
                    </b>
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <List component="ol">
                    {mathAnxietyData.s[this.state.summaryParam].cl.map(
                      (x, i) => (
                        <ListItemText key={"cl" + i}>
                          <Typography>{x}</Typography>
                        </ListItemText>
                      )
                    )}
                  </List>
                </Grid>
                <Grid item xs={12}>
                  <Typography>
                    <b>
                      {mathAnxietyData.s[this.state.summaryParam].subtitle2}
                    </b>
                    <br />
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <Typography>
                    {mathAnxietyData.s[this.state.summaryParam].p2}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <List component="ol">
                    {mathAnxietyData.s[this.state.summaryParam].hl.map(
                      (x, i) => (
                        <ListItemText key={"hl" + i}>
                          <Typography>{x}</Typography>
                        </ListItemText>
                      )
                    )}
                  </List>
                </Grid>
                <Grid item xs={12}>
                  <br />
                  <Grid container justify="center" alignItems="center">
                    <Typography>
                      <Link href="/">Book a Free Trial</Link>
                    </Typography>
                  </Grid>
                  <br />
                  <br />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={12} />

            <Grid item xs={12}>
              <Grid container justify="center" alignItems="center">
                <FormControlLabel
                  className={classes.root}
                  labelPlacement="top"
                  label={mathAnxietyData.qs[this.state.currentPage]}
                  control={
                    <Select
                      autoWidth={true}
                      labelId="label"
                      id="select"
                      value={this.state.selections[this.state.currentPage]}
                      onChange={this.onChange}
                      className={classes.root}
                    >
                      {Object.entries(mathAnxietyData.opts).map(
                        ([key, value]) => {
                          return (
                            <MenuItem
                              key={key}
                              value={value}
                              className={classes.root}
                            >
                              {key}
                            </MenuItem>
                          );
                        }
                      )}
                    </Select>
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" justify="center">
                <IconButton
                  onClick={(e) => this.handleNavigate(e, -1)}
                  disabled={this.state.currentPage === 0}
                >
                  <NavigateBefore />
                </IconButton>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.handleSubmit}
                  disabled={this.state.selections.includes("")}
                >
                  See Results
                </Button>
                <IconButton
                  onClick={(e) => this.handleNavigate(e, 1)}
                  disabled={
                    this.state.currentPage === this.state.selections.length - 1
                  }
                >
                  <NavigateNext />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Container>
    );
  }
}

learningStyles.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(learningStyles);
